jQuery(($) => {
    var iframe = document.getElementById('sketchfab-iframe'),
        uid = $(iframe).attr('model-id');

    if (iframe == null) return;

    // Initialize the Sketchfab client
    var client = new Sketchfab(iframe);

    client.init(uid, {
        camera: 0,
        blending: 1,
        autospin: 0,
        annotation_cycle: 4,
        transparent: 0,
        autostart: 0,
        transparent: 1,
        ui_animations: 0,
        ui_infos: 0,
        ui_stop: 0,
        ui_inspector: 1,
        ui_watermark_link: 0,
        ui_watermark: 0,
        ui_settings: 0,
        ui_fullscreen: 0, 
        scrollwheel: 0,
        ui_theme: 'dark',
        ui_fadeout: 0,
        success: function onSuccess(api) {
            api.start();
            api.addEventListener('viewerready', function () {
                // API is ready
                $('.a-sketchfab-iframe').addClass('ready');

                // Retrieve the default camera position and modify only the Z-axis (zoom)
                api.getCameraLookAt(function (err, camera) {
                    if (!err) {
                        console.log('Default camera position:', camera.position);
                        console.log('Default camera target:', camera.target);

                        // Increase Z-axis to zoom out (e.g., zoom out by 2 units)
                        let newZoom = camera.position[2] * 3.5; // You can adjust the multiplier as needed
                        let newPosition = [camera.position[0], camera.position[1], newZoom];

                        // Set the new camera position with modified zoom
                        api.setCameraLookAt(newPosition, camera.target, 0); // Instant transition (0s)
                    }
                });
            });
        },
        error: function onError() {
            console.error('Error initializing Sketchfab');
        }
    });
});
